import Component from 'vue-class-component'
import TotalsSectionComponent from '@/components/dashboard/lobby/sections/TotalsSection.component.vue'
import DistributionChartSectionComponent
    from '@/components/dashboard/lobby/sections/DistributionChartSection.component.vue'
import ExternalLinksSectionComponent from '@/components/dashboard/lobby/sections/ExternalLinksSection.component.vue'
import MngCompanyMessageSectionComponent
    from '@/components/dashboard/lobby/sections/MngCompanyMessageSection.component.vue'
import EtlJobsSectionComponent from '@/components/dashboard/lobby/sections/EtlJobsSection.component.vue'
import {Action, Getter, Mutation} from 'vuex-class'
import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'

const variables = require('@/assets/styles/_variables.scss')

@Component({
    components: {
        TotalsSectionComponent,
        DistributionChartSectionComponent,
        ExternalLinksSectionComponent,
        MngCompanyMessageSectionComponent,
        EtlJobsSectionComponent
    }
})
export default class LobbyComponent extends AfterFetchComponent {

    @Action('getLobbyData', StoreNamespace.LOBBY) getLobbyData: any;
    @Mutation('setLobbyData', StoreNamespace.LOBBY) setLobbyData: any;
    @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string;

    mounted() {
        this.getLobbyData({requestorCallback: this})
    }

    onSuccess(data?: any, requestName?: any, message?: any) {
        switch (requestName) {
            case 'getLobbyData':
                data.lobbyData.distributionChartSection.distributionChart.datasets[0].backgroundColor = [
                    variables[this.mngCompanyName + '-secondary'],
                    variables[this.mngCompanyName + '-third'],
                    variables[this.mngCompanyName + '-fourth']
                ];
                data.lobbyData.distributionChartSection.distributionChart.labelPrefix = this.$t('logins_in_portal') + ' ';
                data.lobbyData.loginAuditChartSection.datasets[0].borderColor = variables[this.mngCompanyName + '-secondary'];
                data.lobbyData.loginAuditChartSection.datasets[1].borderColor = variables[this.mngCompanyName + '-primary'];
                data.lobbyData.loginAuditChartSection.datasets[2].borderColor = variables[this.mngCompanyName + '-fourth'];
                data.lobbyData.loginAuditChartSection.labelPrefix = this.$t('logins_in_portal') + ' ';

                this.setLobbyData({
                    lobbyData: data.lobbyData,
                    expirationDate: data.expirationDate
                });
                break;
        }
    }

    onReportClick() {
        this.$emit('reportBtnClick')
    }
}
